import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { TicketPreview, Ticket } from '@/modules/Ticket/interfaces/ticket'
import { showErrors } from '@/utils/snack'
import AppTableDate from '@/components/AppTableDate.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppLightModal from '@/components/AppLightModal.vue'
import { getMyTickets, getAllTickets } from '@/modules/Ticket/gql/ticket.gql'
@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppLightModal,
    AppTableDate
  }
})
export default class TicketDashboard extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Ticket'
    }
  ]
  searchVal = ''
  searchAllVal = ''

  tableColumn = [
    { field: '', title: '', slots: { default: 'priority_default' }, fixed: 'left', width: 28 },
    { field: 'name', title: 'Ticket Name', slots: { default: 'name_default' }, resizable: true },
    { field: 'founder', title: 'Founder', resizable: true },
    { title: 'Expected time',
      field: 'expectedTime',
      slots: { default: 'expected_time' },
      resizable: true,
      width: 150
    },
    { field: 'assignees', title: 'Assignees', slots: { default: 'assignees_default' }, resizable: true },
    { field: 'supervisors', title: 'Supervisors', slots: { default: 'supervisors_default' }, resizable: true },
    { field: 'status', title: 'Status', slots: { default: 'status_default' }, resizable: true, width: 130 },
    { title: 'Creation time',
      field: 'createdAt',
      slots: { default: 'created_at' },
      width: 150
    },
    { field: 'closed', title: 'Open/Close', slots: { default: 'closed_default' }, fixed: 'right', width: 120 }
  ]

  windowSize = {
    w: 0,
    h: 0
  }

  myHotTickets: TicketPreview[] = []
  allHotTickets: TicketPreview[] = []

  tableLoading = false

  myTicketLoading = false

  mounted () {
    this.onResize()
    this.getMyTickets()
    this.getAllTickets()
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    this.routeTo('TicketDetail', {
      id: item.id
    })
  }

  async getMyTickets () {
    this.myTicketLoading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getMyTickets,
        variables: {
          paging: {
            offset: 0,
            limit: 6
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const myTopTickets = result.data.getMyTickets.tickets.map((ticket: Ticket) => {
        return Object.assign({}, ticket, {
          showLabels: false
        })
      })
      this.myTicketLoading = false
      this.myHotTickets = myTopTickets
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getAllTickets () {
    this.tableLoading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAllTickets,
        variables: {
          paging: {
            offset: 0,
            limit: 10
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const allTopTickets = result.data.getAllTickets.tickets
      this.allHotTickets = allTopTickets.map((ticket: Ticket) => {
        return this.$R.merge(ticket, {
          founder: ticket.users.founder.username,
          supervisors: this.$R.map((supervisor: any) => {
            return supervisor.username
          }, ticket.users.supervisors),
          assignees: this.$R.map((assignee: any) => {
            return assignee.username
          }, ticket.users.assignees)
        })
      })
      this.tableLoading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
